import { View, Text, StyleSheet, Pressable, Modal } from 'react-native';
import React, { useState } from 'react';
import GenericButton from '../../../components/molecules/buttons/GenericButton';
import InvitationUserDetails from './InvitationUserDetails';
import { IInvitation } from '../../../types/invitation';
import SendUserInviteModal from '../../../modal/SendUserInviteModal';

interface IInvitationUserItemProps {
  user: IInvitation;
}

/**
 * InvitationUserItem component
 *
 * @param {*} { user }
 * @return {*}
 */
const InvitationUserItem: React.FC<IInvitationUserItemProps> = ({ user }) => {
  const [sendUserInviteModalOpen, setSendUserInviteModalOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  const onOpenDetails = () => {
    setVisible(true);
  };

  const onOpenSendUserInviteModal = () => {
    setSendUserInviteModalOpen(true);
  };

  return (
    <>
      <Modal visible={visible}>
        <InvitationUserDetails user={user} setVisible={setVisible} />
      </Modal>
      <SendUserInviteModal
        isVisible={sendUserInviteModalOpen}
        onClose={() => setSendUserInviteModalOpen(false)}
        invitation={user}
      />
      <Pressable onPress={() => onOpenDetails()}>
        <View style={styles.card}>
          <View style={styles.userInfo}>
            <View style={styles.avatarContainer}>
              <Text style={styles.avatarText}>
                {user.tenant_name?.charAt(0).toUpperCase() || 'U'}
              </Text>
            </View>
            <View style={styles.textContainer}>
              <Text style={styles.name}>{user.tenant_name}</Text>
              <Text style={styles.email}>{user.email}</Text>
              <Text style={styles.status}>Invitation Pending</Text>
            </View>
          </View>
          <GenericButton
            title={'Resend Invitation'}
            onPress={onOpenSendUserInviteModal}
            isPrimary={false}
            buttonStyle={styles.button}
            textStyle={styles.buttonText}
          />
        </View>
      </Pressable>
    </>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: '#ffffff',
    borderRadius: 8,
    marginHorizontal: 16,
    marginVertical: 8,
    padding: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 3,
    borderLeftWidth: 4,
    borderLeftColor: '#ffc107'
  },
  userInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1
  },
  avatarContainer: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: '#ffc107',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12
  },
  avatarText: {
    color: '#ffffff',
    fontSize: 18,
    fontWeight: '600'
  },
  textContainer: {
    flex: 1
  },
  name: {
    fontSize: 16,
    fontWeight: '600',
    color: '#212529',
    marginBottom: 2
  },
  email: {
    fontSize: 14,
    fontWeight: '400',
    color: '#6c757d',
    marginBottom: 2
  },
  status: {
    fontSize: 12,
    fontWeight: '500',
    color: '#ffc107'
  },
  button: {
    width: 140,
    height: 36,
    borderRadius: 6
  },
  buttonText: {
    fontSize: 13,
    fontWeight: '600'
  }
});

export default InvitationUserItem;
